import { connect } from 'react-redux';

import { IOfferCardAsideDispatchProps, IOfferCardAsideStoreProps, OfferCardAside } from './index';
import { setHeight } from '../../store/navigation';

import type { DispatchReduxAction, IState } from '../../store';

function mapStateToProps(state: IState): IOfferCardAsideStoreProps {
  return {
    height: state.aside.height,
    isNavigationActive: state.aside.isNavigationActive,
  };
}

function mapDispatchToProps(dispatch: DispatchReduxAction): IOfferCardAsideDispatchProps {
  return {
    setHeight: (height: number) => dispatch(setHeight(height)),
  };
}

export const OfferCardAsideContainer = connect<IOfferCardAsideStoreProps, IOfferCardAsideDispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferCardAside);
